<template>
  <div class="ArticleCard shadow">
    <div
      class="article-card-image-container position-relative"
      @click="navigate('/stand-alone-article/' + item.id)"
    >
      <div class="w-100 h-100 clickable d-flex justify-content-center">
        <img
          class="img-fluid image-class"
          :src="item.thumbnail"
          v-if="item.thumbnail"
        />
        <img
          class="img-fluid image-class-2 h-100 px-5"
          src="/img/wellbeing-studio/wellbeing-studio.svg"
          v-else
        />
      </div>
    </div>
    <div class="article-card-meta-container">
      <div
        class="d-flex flex-row flex-nowrap justify-content-between align-items-start w-100"
      >
        <div class="article-card-title brand-text clickable">
          {{ item.title }}
        </div>
        <ContentCardTags :tags="filteredTags" class="article-card-tags" />
      </div>
      <p v-if="item.description" class="description truncate-3 p-text-sm pt-3">
        {{ item.description }}
      </p>
      <div
        class="mt-auto d-flex flex-row align-items-center justify-content-between justify-self-end"
      >
        <b-button
          @click="navigate('/stand-alone-article/' + item.id)"
          variant="white"
          size="lg"
          style="margin-left: -15px"
          >Find out more <i class="fa-regular ml-2 fa-chevron-right"></i
        ></b-button>
      </div>
    </div>
  </div>
</template>
<script>
import ContentCardTags from "@/components/Home/New/ContentCardTags.vue";

export default {
  name: "ArticleCard",
  props: {
    item: Object
  },
  components: {
    ContentCardTags
  },
  data() {
    return {};
  },
  computed: {
    filteredTags() {
      if (!this.item.tags) return [];
      const allowedTags = ["life", "body", "mind"];
      return this.item.tags.filter(tag =>
        allowedTags.includes(tag.toLowerCase())
      );
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    navigate(route) {
      this.$router.push(route);
      this.scrollToRef(null, true);
    }
  }
};
</script>
<style lang="less">
.ArticleCard {
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: inherit !important;

  .article-card-image-container {
    aspect-ratio: 16/9 !important;
    overflow: hidden;
    background-color: transparent;
    cursor: pointer;

    .image-class {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    .image-class-2 {
      background-color: #eee !important;
    }
  }

  .article-card-meta-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: flex-start;
    background-color: white;
    padding: 20px 20px 10px 20px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;

    .article-card-title {
      align-self: flex-start;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      font-family: "FilsonProBold", sans-serif;
      font-size: 1.8rem;
      // Always reserve two lines so 1-line and 2-line titles produce equal-height
      // cards — prevents the carousel from jumping when flicking between pages.
      min-height: 70px;
      max-height: 70px;
    }

    .article-card-tags {
      align-self: flex-start;
      margin-left: auto;
    }

    .description {
      font-family: "FilsonPro", sans-serif;
      font-size: 1.4rem;
    }
  }

  .truncate-3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    /* number of lines to show */
    line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
</style>
